import { create } from 'zustand';

// Open/close toggle for the single <FeedbackDialog> mounted in App.tsx.
// Any trigger (FAB, help page button, etc.) just calls setOpen(true).
interface FeedbackDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useFeedbackDialogStore = create<FeedbackDialogState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
